import type { PackagingItemComplianceRedFlag } from '@/shared/hooks/api/packagingItemsOverview'

export const PACKAGING_ITEM_COMPLIANCE_RED_FLAG_VALUES = [
  'HEAVY_METALS',
  'SUBSTANCES_OF_CONCERN',
] as const satisfies readonly PackagingItemComplianceRedFlag[]
